export enum ProductConfiguratorMode {
  CONFIGURATION = "configuration",
  DIMENSIONING = "dimensioning"
}
